import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultOccFormDisplayText = {
    fieldOptionalSuffix: ' (optional)',
    passwordRuleCheckerHelpText: 'Password must contain:'
};
export const occFormDisplayTextValidator = Validator.object({
    fieldOptionalSuffix: nonEmptyStringValidator,
    passwordRuleCheckerHelpText: nonEmptyStringValidator
});
